import React from "react";
import { Card, Icon } from "antd";
import "../FleetOverviewCard/style.css";
import "./style.css";

/**
 * StatusCard
 *
 * A single card that shows one or more operational-status KPIs as side-by-side
 * zones (e.g. Unserviceable Equipment | Open Complaints), divided the same way as
 * FleetOverviewCard and sharing its styles, so the whole summary row reads as one
 * consistent set at one height.
 *
 * Purely presentational. `fmt()` renders "—" for missing/non-numeric values so a
 * real 0 stays distinct from "not available". Nothing is fetched or derived here.
 *
 * Props:
 *   loading  – show the card skeleton while any source figure is still loading
 *   items[]  – one entry per zone: { icon, label, value, helper, helperType,
 *              actionLabel, onAction }
 */

const fmt = (n) => {
    if (n === null || n === undefined || (typeof n === "number" && isNaN(n))) return "—";
    return Number(n).toLocaleString();
};

const StatusCard = ({ loading = false, items = [] }) => {
    return (
        <Card loading={loading} className="gx-card-widget fo-card sc-card" bordered={false}>
            <div className="fo-inner sc-inner">
                {items.map((item, i) => (
                    <React.Fragment key={item.label || i}>
                        {i > 0 && <div className="fo-div" />}
                        <div className="fo-total sc-total">
                            <div className="fo-eyebrow">{item.label}</div>
                            <div className="sc-body">
                                <div className="fo-total-main">
                                    {item.icon ? <img className="fo-total-ico" src={item.icon} alt="" /> : null}
                                    <div className="fo-big">{fmt(item.value)}</div>
                                </div>
                                {(item.helper || item.onAction) && (
                                    <div className="sc-helper-row">
                                        {item.helper ? (
                                            <span className={`sc-helper sc-${item.helperType || "muted"}`}>{item.helper}</span>
                                        ) : null}
                                        {item.onAction ? (
                                            <a className="sc-link" onClick={item.onAction}>
                                                <Icon type="download" /> {item.actionLabel || "View"}
                                            </a>
                                        ) : null}
                                    </div>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </Card>
    );
};

export default StatusCard;
